var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course_container-warp"},[_c('SearchInput',{attrs:{"descPlaceHolder":"请输入关键词","path":"/search"}}),_c('router-view'),_c('cartoon-kid',{attrs:{"homeUserInfo":_vm.userInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }